export const cart = {
  cartDetails: {
    id: 'ID',
    proceedToCheckout: 'Passer à la caisse',
    cartName: 'Panier n°{{code}}',
  },
  cartItems: {
    id: 'Numéro de code',
    description: 'Description',
    item: 'Article',
    itemPrice: 'Prix de l\'article',
    quantity: 'Qté',
    quantityTitle: 'La quantité représente le nombre total de cet article dans votre panier.',
    total: 'Total',
    actions: 'Actions',
    cartTotal: 'Total du panier ({{count}} article)',
    cartTotal_other: 'Total du panier ({{count}} articles)',
    itemRemoved: 'L\'article sélectionné a été supprimé. Le total du panier a été mis à jour.',
    caption: 'Contenu du panier.',
    netPrice: 'Prix net',
  },
  orderCost: {
    orderSummary: 'Sommaire de la commande',
    subtotal: 'Sous-total après rabais :',
    shipping: 'Livraison :',
    estimatedShipping: 'Livraison estimée :',
    discount: 'Vous avez économisé :',
    salesTax: 'Taxes de vente :',
    grossTax: 'Le total de la commande n\'inclut pas la taxe de',
    grossIncludeTax: 'Le total de la commande inclut la taxe de',
    total: 'Total :',
    toBeDetermined: 'À déterminer',
    pricingNotice:
      'Avis relatif aux prix:  Des prix réduits sont affichés sur l’ensemble de la plateforme ATG Connect. Un montant de commande minimum de 300 $ (prix de liste) est requis pour bénéficier de ces prix réduits.  Les commandes inférieures au minimum seront facturées aux prix standard.',
    orderMinimumNotice: 'Avis concernant le montant minimum de commande:  Les commandes inférieures à 250 $ sont soumises à des frais traitement de 25 $.',
  },
  voucher: {
    coupon: 'Vous avez un coupon?',
    coupon_other: 'Codes de coupon',
    couponLabel: 'Saisir un code promotionnel ici',
    apply: 'Appliquer',
    placeholder: 'Code promotionnel',
    applyVoucherSuccess: '{{voucherCode}} a été appliqué.',
    removeVoucherSuccess: '{{voucherCode}} a été supprimé.',
    anchorLabel: 'Saisir ou supprimer votre code de coupon',
    vouchersApplied: 'Coupons appliqués',
    availableCoupons: 'Coupons disponibles',
    availableCouponsLabel: 'Vous pouvez ajouter ces coupons à cette commande.',
  },
  saveForLaterItems: {
    itemTotal: 'Sauvegardé pour plus tard ({{count}} article)',
    itemTotal_other: 'Sauvegardé pour plus tard ({{count}} articles)',
    cartTitle: 'Panier',
    saveForLater: 'Sauvegarder pour plus tard',
    moveToCart: 'Déplacer vers le panier',
    stock: 'Stock',
    forceInStock: 'En stock',
  },
  clearCart: {
    clearCart: 'Vider le panier',
    clearingCart: 'Vidage du panier...',
    cartClearedSuccessfully: 'Le panier actif a été vidé avec succès.',
    areYouSureToClearCart: 'Êtes-vous sûr de vouloir vider ce panier?',
    allItemsWillBeRemoved: 'Tous les articles de votre panier actif seront supprimés.',
  },
  validation: {
    cartEntriesChangeDuringCheckout: 'Des problèmes ont été détectés avec vos articles lors du passage à la caisse. Veuillez réviser votre panier.',
    cartEntryRemoved: '{{name}} a été retiré du panier car il est en rupture de stock.',
    productOutOfStock: '{{name}} a été retiré du panier en raison d\'un stock insuffisant.',
    lowStock: 'La quantité a été réduite à {{quantity}} en raison d\'un stock insuffisant.',
    reviewConfiguration: 'Résolvez d\'abord les problèmes de configuration du poste du panier.',
    configurationError: 'Résolvez d\'abord les problèmes de configuration des postes du panier.',
    pricingError: 'La tarification du configurateur n\'est pas disponible pour le moment. Le passage à la caisse ou la soumission de soumission n\'est pas possible. Veuillez réessayer plus tard.',
    unresolvableIssues: 'La configuration du produit nécessite des entrées supplémentaires dans le système. Par conséquent, vous ne pouvez pas continuer. Veuillez contacter le support.',
    inProgress: 'En traitement',
  },
};
